/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GroupProgressResponse = zod.object({
  weekStart: zod.iso.date(),
  today: zod.iso.date(),
  you: zod.object({
    leader: zod.boolean(),
  }),
  members: zod.array(
    zod.object({
      actorUuid: zod.uuid(),
      name: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      photoUrl: zod.string().nullable(),
      leader: zod.boolean().describe('Holds Admin: a Group Leader or a Facilitator'),
      facilitator: zod.boolean(),
      you: zod.boolean(),
      reported: zod.boolean().describe('The group can read a summary of theirs'),
      target: zod.int(),
      done: zod.int(),
      daysDone: zod.array(zod.iso.date()).describe('Days of the week with all three done'),
      summary: zod
        .object({
          currentStreak: zod.int(),
          bestStreak: zod.int(),
          sessionsThisMonth: zod.int(),
          sessionsTotal: zod.int().nullable(),
          completionByKind: zod.object({
            read: zod.int(),
            write: zod.int(),
            math: zod.int(),
          }),
          asOf: zod.iso.date(),
        })
        .nullable()
        .describe("The numbers of the member's newest summary"),
      days: zod
        .array(
          zod.object({
            date: zod.iso.date(),
            read: zod
              .union([zod.literal('self'), zod.literal('leader'), zod.literal(null)])
              .nullable()
              .describe('Who finished it: the member, a leader marking it, or nobody yet'),
            write: zod
              .union([zod.literal('self'), zod.literal('leader'), zod.literal(null)])
              .nullable()
              .describe('Who finished it: the member, a leader marking it, or nobody yet'),
            math: zod
              .union([zod.literal('self'), zod.literal('leader'), zod.literal(null)])
              .nullable()
              .describe('Who finished it: the member, a leader marking it, or nobody yet'),
          }),
        )
        .optional()
        .describe('Monday to Sunday, exercise by exercise'),
      marks: zod
        .array(
          zod
            .object({
              date: zod.iso.date(),
              kind: zod.enum(['read', 'write', 'math']),
              lineageUuid: zod.uuid(),
              leaderActorUuid: zod.uuid(),
              changedAt: zod.iso.datetime({ offset: true }),
            })
            .describe('A mark made in this group that still says done'),
        )
        .optional()
        .describe('For leaders only'),
    }),
  ),
});

export type GroupProgressResponse = zod.input<typeof GroupProgressResponse>;
export type GroupProgressResponseOutput = zod.output<typeof GroupProgressResponse>;
